import { NavLink } from "react-router-dom";
import { Menu } from "antd";
import { profileSVg, signInSvg, signUpSvg } from "./SignInUpData";
import { useAuth } from "../AuthContext";

const color = "#619b04";

export const dashboard = () => [
  <svg
    width="20"
    height="20"
    viewBox="0 0 20 20"
    xmlns="http://www.w3.org/2000/svg"
    key={0}
  >
    <path
      d="M3 4C3 3.44772 3.44772 3 4 3H16C16.5523 3 17 3.44772 17 4V6C17 6.55228 16.5523 7 16 7H4C3.44772 7 3 6.55228 3 6V4Z"
      fill={color}
    ></path>
    <path
      d="M3 10C3 9.44771 3.44772 9 4 9H10C10.5523 9 11 9.44771 11 10V16C11 16.5523 10.5523 17 10 17H4C3.44772 17 3 16.5523 3 16V10Z"
      fill={color}
    ></path>
    <path
      d="M14 9C13.4477 9 13 9.44771 13 10V16C13 16.5523 13.4477 17 14 17H16C16.5523 17 17 16.5523 17 16V10C17 9.44771 16.5523 9 16 9H14Z"
      fill={color}
    ></path>
  </svg>,
];

const getItem = (label, path, icon, pathName) => {
  return (
    <NavLink to={path}>
      <span
        className="icon"
        style={{
          background: pathName === path.replace("/", "") ? color : "",
        }}
      >
        {icon}
      </span>
      <span className="label">{label}</span>
    </NavLink>
  );
};

export const items = (pathname, user) => {
  const apps = user?.TenantApps || ["indigent", "lending", "leads"];
  const canIndigent = apps.includes("indigent");
  const canLending = apps.includes("lending");
  const canLeads = apps.includes("leads");
  const list = [];

  if (user && [1, 2, 3, 4, 5].includes(user.RoleId) && canIndigent) {
    list.push({
      key: "indigents",
      label: getItem(
        "Indigents",
        "/tables",
        <svg
          width="20"
          height="20"
          viewBox="0 0 20 20"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
          key={0}
        >
          <path
            d="M9 2C8.44772 2 8 2.44772 8 3C8 3.55228 8.44772 4 9 4H11C11.5523 4 12 3.55228 12 3C12 2.44772 11.5523 2 11 2H9Z"
            fill={color}
          ></path>
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M4 5C4 3.89543 4.89543 3 6 3C6 4.65685 7.34315 6 9 6H11C12.6569 6 14 4.65685 14 3C15.1046 3 16 3.89543 16 5V16C16 17.1046 15.1046 18 14 18H6C4.89543 18 4 17.1046 4 16V5ZM7 9C6.44772 9 6 9.44772 6 10C6 10.5523 6.44772 11 7 11H7.01C7.56228 11 8.01 10.5523 8.01 10C8.01 9.44772 7.56228 9 7.01 9H7ZM10 9C9.44772 9 9 9.44772 9 10C9 10.5523 9.44772 11 10 11H13C13.5523 11 14 10.5523 14 10C14 9.44772 13.5523 9 13 9H10ZM7 13C6.44772 13 6 13.4477 6 14C6 14.5523 6.44772 15 7 15H7.01C7.56228 15 8.01 14.5523 8.01 14C8.01 13.4477 7.56228 13 7.01 13H10ZM10 13C9.44772 13 9 13.4477 9 14C9 14.5523 9.44772 15 10 15H13C13.5523 15 14 14.5523 14 14C14 13.4477 13.5523 13 13 13H10Z"
            fill={color}
          ></path>
        </svg>,
        pathname
      ),
    });
  }

  if (user && user.RoleId === 5) {
    list.push({
      key: "admin",
      label: getItem(
        "Admin",
        "/admin",
        <svg
          width="20"
          height="20"
          viewBox="0 0 20 20"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
          key="admin-icon"
        >
          <circle cx="10" cy="10" r="8" stroke={color} strokeWidth="2" />
          <path d="M10 5V10L13 12" stroke={color} strokeWidth="2" />
        </svg>,
        pathname
      ),
    });
    if (canIndigent) {
      list.push({
        key: "insights",
        label: getItem(
          "Insights",
          "/tables2",
          <svg
            width="20"
            height="20"
            viewBox="0 0 20 20"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            key={0}
          >
            <path
              d="M9 2C8.44772 2 8 2.44772 8 3C8 3.55228 8.44772 4 9 4H11C11.5523 4 12 3.55228 12 3C12 2.44772 11.5523 2 11 2H9Z"
              fill={color}
            ></path>
            <path
              fillRule="evenodd"
              clipRule="evenodd"
              d="M4 5C4 3.89543 4.89543 3 6 3C6 4.65685 7.34315 6 9 6H11C12.6569 6 14 4.65685 14 3C15.1046 3 16 3.89543 16 5V16C16 17.1046 15.1046 18 14 18H6C4.89543 18 4 17.1046 4 16V5ZM7 9C6.44772 9 6 9.44772 6 10C6 10.5523 6.44772 11 7 11H7.01C7.56228 11 8.01 10.5523 8.01 10C8.01 9.44772 7.56228 9 7.01 9H7ZM10 9C9.44772 9 9 9.44772 9 10C9 10.5523 9.44772 11 10 11H13C13.5523 11 14 10.5523 14 10C14 9.44772 13.5523 9 13 9H10ZM7 13C6.44772 13 6 13.4477 6 14C6 14.5523 6.44772 15 7 15H7.01C7.56228 15 8.01 14.5523 8.01 14C8.01 13.4477 7.56228 13 7.01 13H10ZM10 13C9.44772 13 9 13.4477 9 14C9 14.5523 9.44772 15 10 15H13C13.5523 15 14 14.5523 14 14C14 13.4477 13.5523 13 13 13H10Z"
              fill={color}
            ></path>
          </svg>,
          pathname
        ),
      });
    }
  }

  if (user && canLeads) {
    list.push(
      {
        key: "leads",
        label: getItem(
          "Leads",
          "/leads",
          <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg" key="leads-icon">
            <circle cx="6" cy="7" r="3" stroke={color} strokeWidth="2" />
            <path d="M11 14c0-2.5-2.2-4-5-4s-5 1.5-5 4" stroke={color} strokeWidth="2" />
            <path d="M14 7h5" stroke={color} strokeWidth="2" />
            <path d="M14 11h4" stroke={color} strokeWidth="2" />
          </svg>,
          pathname
        ),
      },
      {
        key: "lead-inbox",
        label: getItem(
          "Lead Inbox",
          "/lead-inbox",
          <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg" key="lead-inbox-icon">
            <rect x="3" y="4" width="14" height="12" rx="2" stroke={color} strokeWidth="2" />
            <path d="M3 9h5l2 2h2l2-2h5" stroke={color} strokeWidth="2" />
          </svg>,
          pathname
        ),
      },
      {
        key: "bookings",
        label: getItem(
          "Bookings",
          "/bookings",
          <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg" key="bookings-icon">
            <rect x="3" y="4" width="14" height="13" rx="2" stroke={color} strokeWidth="2" />
            <path d="M3 8h14" stroke={color} strokeWidth="2" />
            <path d="M6 2v4M14 2v4" stroke={color} strokeWidth="2" />
          </svg>,
          pathname
        ),
      },
      {
        key: "invoices",
        label: getItem(
          "Invoicing",
          "/invoices",
          <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg" key="invoice-icon">
            <rect x="4" y="3" width="12" height="14" rx="2" stroke={color} strokeWidth="2" />
            <path d="M6 7h8M6 11h6" stroke={color} strokeWidth="2" />
          </svg>,
          pathname
        ),
      },
      {
        key: "reports",
        label: getItem(
          "Reports",
          "/reports",
          <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg" key="reports-icon">
            <path d="M4 16V4h12v12H4z" stroke={color} strokeWidth="2" />
            <path d="M7 13V9M10 13V6M13 13V10" stroke={color} strokeWidth="2" />
          </svg>,
          pathname
        ),
      }
    );
  }

  if (user && canLending) {
    list.push({
      key: "applications",
      label: getItem(
        "Applications",
        "/applications",
        <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg" key="applications-icon">
          <rect x="4" y="3" width="12" height="14" rx="2" stroke={color} strokeWidth="2" />
          <path d="M7 7h6M7 11h6M7 15h4" stroke={color} strokeWidth="2" />
        </svg>,
        pathname
      ),
    });
  }

  return list;
};

const MenuItem = ({ pathname }) => {
  const { user } = useAuth();
  return <Menu mode="inline" theme="light" items={items(pathname, user)} />;
};

export default MenuItem;
